'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UIFlex from 'UIComponents/layout/UIFlex';
import { device } from '../constants/StyledComponentConstants';
import useMediaQuery from '../hooks/useMediaQuery';
export const CardGridWrapper = styled.div.withConfig({
  displayName: "ResponsiveCardGridContainer__CardGridWrapper",
  componentId: "sc-1bh6jkw-0"
})(["@media screen and ", "{&::-webkit-scrollbar{width:0;background:transparent;height:0;}}overflow-x:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;padding-top:8px;margin-top:-8px;&.noBorder{.mobileCardScroll{border-bottom:0;}}&.noPadding{.mobileCardScroll{padding-bottom:0;}}"], device.mobile);
const ResponsiveUICardGrid = styled(UICardGrid).withConfig({
  displayName: "ResponsiveCardGridContainer__ResponsiveUICardGrid",
  componentId: "sc-1bh6jkw-1"
})(["padding-bottom:30px;"]);
const MobileCardScrollUIFlex = styled(UIFlex).withConfig({
  displayName: "ResponsiveCardGridContainer__MobileCardScrollUIFlex",
  componentId: "sc-1bh6jkw-2"
})(["max-width:unset;width:", "%;padding-right:16px;padding-bottom:20px;margin-bottom:4px;&& > *{max-width:", ";&:only-child{max-width:calc(100vw - 30px);}}"], props => 85 * (props.columns || 2), props => props.maxCardWidth);
const CardRow = styled(UIFlex).withConfig({
  displayName: "ResponsiveCardGridContainer__CardRow",
  componentId: "sc-1bh6jkw-3"
})(["&& > *{min-width:", "px;margin-right:", "px;max-width:", ";}&& > *:last-child{margin-right:0;}max-width:unset;min-width:fit-content;"], props => props.minCardWidth, props => props.gutterSize, props => props.maxCardWidth);

const ResponsiveCardGridContainer = (_ref) => {
  let {
    children,
    className,
    columns,
    columnSize,
    gutterSize,
    maxCardWidth,
    nowrap
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "className", "columns", "columnSize", "gutterSize", "maxCardWidth", "nowrap"]);

  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsx(CardGridWrapper, {
    className: className,
    children: isMobile ? /*#__PURE__*/_jsx(MobileCardScrollUIFlex, {
      align: "stretch",
      className: "mobileCardScroll",
      columns: columns,
      maxCardWidth: maxCardWidth ? `${maxCardWidth}px` : 'unset',
      children: children
    }) : nowrap ? /*#__PURE__*/_jsx(CardRow, {
      align: "stretch",
      gutterSize: gutterSize,
      maxCardWidth: maxCardWidth ? `${maxCardWidth}px` : 'unset',
      minCardWidth: columnSize,
      children: children
    }) : /*#__PURE__*/_jsx(ResponsiveUICardGrid, Object.assign({
      columnSize: columnSize,
      columns: columns,
      gutterSize: gutterSize
    }, restProps, {
      children: children
    }))
  });
};

ResponsiveCardGridContainer.defaultProps = Object.assign({}, UICardGrid.defaultProps);
export default ResponsiveCardGridContainer;